import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { Shield, MonitorSmartphone, Landmark, MapPin } from 'lucide-react';

const badges = [
  { icon: Shield, label: 'HIPAA COMPLIANT' },
  { icon: MonitorSmartphone, label: 'EPIC / CERNER READY' },
  { icon: Landmark, label: '$50B FEDERAL MANDATE ALIGNED' },
  { icon: MapPin, label: 'MIDWEST-FIRST GTM' },
];

export default function TrustBar() {
  const [ref, isVisible] = useScrollAnimation(0.2);

  return (
    <section data-testid="trust-bar-section" className="py-6 md:py-8 -mt-4 relative z-10">
      <div
        ref={ref}
        className={`max-w-4xl mx-auto px-4 md:px-8 scroll-fade-up ${isVisible ? 'visible' : ''}`}
      >
        <div className="bg-white/80 backdrop-blur-xl border border-vf-sage shadow-sm py-5 px-6 md:px-10">
          <div className="stagger-children visible grid grid-cols-2 md:grid-cols-4 gap-5 md:gap-6">
            {badges.map((badge, i) => (
              <div key={badge.label} className={`flex items-center gap-3 justify-center ${i < badges.length - 1 ? 'md:border-r md:border-vf-sage/40' : ''} md:pr-4`}>
                <badge.icon size={18} strokeWidth={1.5} className="text-vf-forest shrink-0" />
                <span className="font-body text-[10px] md:text-[11px] uppercase tracking-[0.18em] text-vf-charcoal font-bold leading-tight">
                  {badge.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
